module.exports = __webpack_public_path__ + "static/no-image-asesor-6e0bb1799cc37ce81445675e6535a0e2.png";